import {
  fetchClient
} from "./chunk-SKVXOXWB.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/hy/coupon/verify.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var verifyHyCoupon = (_0) => __async(void 0, [_0], function* ({ venue_id, booking_date, code, locale }) {
  var _a, _b;
  try {
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: `/payment/verify-coupon?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          lang,
          code,
          venue_id,
          booking_date
        })
      }
    });
    if (((_a = data == null ? void 0 : data.status) == null ? void 0 : _a.toLowerCase()) !== "success") {
      const possibleErrors = (data == null ? void 0 : data.error) || {};
      const firstError = typeof possibleErrors === "string" ? possibleErrors : (_b = Object.values(possibleErrors)) == null ? void 0 : _b[0];
      const firstMsg = typeof firstError === "string" ? firstError : firstError == null ? void 0 : firstError[0];
      throw new Error(firstMsg || "something went wrong");
    }
    return data.coupon;
  } catch (error) {
    throw new Exception({ error, name: "verifyHyCouponException" });
  }
});

export {
  verifyHyCoupon
};
//# sourceMappingURL=chunk-75FO4HW4.mjs.map